module.exports = __webpack_public_path__ + "img/14.86065f61.png";